// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBox_wrapper__iaAI1"};